import React , {useEffect} from "react";
import { Link , useLocation } from "react-router-dom";

const KindFoodCardDetails = ({ kind , searchQuery }) => {
 
  
  return (
    <Link to={`/chooseFood`}
     state={{target:kind.idNmae}}
    >
      <div className="bg-gray-300 dark:bg-gray-600  backdrop-blur-lg rounded-xl drop-shadow-lg p-1">
        <img
          src={kind.image}
          className="w-48 text-center rounded mx-auto mb-1"
          alt=""
        />
        <p className="text-center bg-white rounded-b-md dark:bg-gray-950 dark:text-white ">{kind.title}</p>
      </div>
    </Link>
  );
};

export default KindFoodCardDetails;
